module.exports = __webpack_public_path__ + "static/media/BIN.9661b410.svg";